module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAABO0lEQVR4AWSQv0vDUBDH7y5UsTXo6CQKLv4BDg4iKApCQQS7OWqcKm3Tan+IZKgpJG2KOllc3FTQxUkQOjiIk3TXraMitOgQYs9rwNDSxx3ve/f93PF4BHKSGXNRLpQcCEqlzV1x6nrmuGYYhj/QSxEDviPCDyBut75Dl7HYjdIHVMu5xw7DGjC0EHFrcvrtStPOQ/+Qv7Jq55889lal+SW5OTr2eRePnw6LBh/oipPy0Qt7uAzMH4gQDY207zXNCAdAF3Kc3CsQbzADI+CKOj503QcksqUpZqzJBpSBJnt0GAC6XppTOvyMgLNiNlxw5x0n2/CBZLq4DgrXxZiQfFBAWTizjKZooNR+cQ+RbqWIyAMv1LAbtayDttR+EDLNiCJgKFTswo78pid1EKRG3AQpv0sVO28G3R7xBwAA//+bmKFkAAAABklEQVQDACwoY0xbYllvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/right-arrow.png
// module id = Uxt/
// module chunks = 2